import React,{useState, useEffect} from 'react';
import './App.css';
import {GiCheckMark} from 'react-icons/gi';
import { HiMenu,HiBriefcase,HiArrowRight } from 'react-icons/hi';
import {BiUser,BiSend,BiCodeCurly,BiChevronDown} from 'react-icons/bi';
import { GoFile,GoCode,GoCalendar } from "react-icons/go";
import Modal from 'react-modal';
import {FaLinkedinIn,FaInstagram,FaFacebookF,FaServer,FaNetworkWired,FaTimes,FaBriefcase, FaUserGraduate} from 'react-icons/fa';


Modal.setAppElement('#root');
function App() {

  const [toggleMenu, setToggleMenu] = useState(false);
  const [largeur, setLargeur] = useState(window.innerWidth)
  const toggleNavSmoolMenu = () =>{
    setToggleMenu(!toggleMenu)
  }
  useEffect(()=>{
    const changewidth = () =>{
      setLargeur(window.innerWidth);

      if(window.innerWidth >850){
        setToggleMenu(false)
      }
    }
    window.addEventListener('resize', changewidth);
    return () =>{
      window.removeEventListener('resize', changewidth);
    }

  },[])


        const [etat1, setEtat1] = useState(true);
        const [etat2, setEtat2] = useState(false);
        const [etat3, setEtat3] = useState(false);

        const toogleclik1 = () =>{
              setEtat1(!etat1);
              setEtat3(false); 
              setEtat2(false);    
        }
        const toogleclik2 = () =>{
          setEtat2(!etat2);
          setEtat1(false);
          setEtat3(false);

    }
    const toogleclik3 = () =>{
      setEtat3(!etat3);
      setEtat2(false);
          setEtat1(false);     
}
 /*       
const tabs = document.querySelectorAll('[data-traget]');
const tabContenets = document.querySelectorAll('[data-content]');
tabs.forEach(tab =>{
  tab.addEventListener('click', () =>{
    const traget = document.querySelector(tab.dataset.target);
    tabContenets.forEach(tabContenet =>{
      tabContenet.className.remove('quali__active');
    })
    traget.className.add('quali__active');

    tab.forEach(tab =>{
      tab.className.remove('quali__active');
    })
    tab.className.add('quali__active');
  })
})
*/
const [etude, setEtude] = useState(true);
const activeWork = () =>{
  setEtude(!etude);
}

const [modalIsOpen, setIsOpen] = React.useState(false);
const [modalIsOpen1, setIsOpen1] = React.useState(false);
const [modalIsOpen2, setIsOpen2] = React.useState(false);

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

function openModal() {
  setIsOpen(true);
}

function closeModal() {
  setIsOpen(false);
}


function openModal1() {
  setIsOpen1(true);
}

function closeModal1() {
  setIsOpen1(false);
}


function openModal2() {
  setIsOpen2(true);
}

function closeModal2() {
  setIsOpen2(false);
}

  return (
    <div className="App" >    
    <header className='header'>
      <nav className='nav'>
        <div className='nav__menu' >
        {(toggleMenu || largeur > 850)  &&(
          <ul className='nav__list grid'>
            <li className='nav__item'>
              <a href='#home' className='nav__link'>
               <BiUser className='nav__icon' /><br></br>A propos
              </a>
            </li>
            <li className='nav__item'>
              <a href='#skills' className='nav__link'>
              <GoCode className='nav__icon' /><br></br>compétences
              </a>
            </li>
            <li className='nav__item'>
              <a href='#qualification' className='nav__link'>
              <GoFile className='nav__icon' /><br></br>Qualifications
              </a>
            </li>
            <li className='nav__item'>
              <a href='#service' className='nav__link'>
              <HiBriefcase className='nav__icon' /><br></br>Services
              </a>
            </li>
          </ul>
        )}
          
          <div className='btn' onClick={toggleNavSmoolMenu}><HiMenu /></div>
        </div>
      </nav>
    </header>
    <main>
          <section className='section__apropo'>
            
              <div className='social'>
                <ul className='ul__social'>
                  <li className='items__social'>
                  <a href='https://www.linkedin.com/in/abdel-nasser-saley-diori-353592147/' target="_blank" className='lienRX'> <FaLinkedinIn /> </a>
                  </li>
                  <li className='items__social'>
                  <a href='https://www.instagram.com/saleynasser/' target="_blank" className='lienRX'> <FaInstagram />   </a>
                  </li>
                  <li className='items__social'>
                    <a href='https://www.facebook.com/profile.php?id=100004181018098' target="_blank" className='lienRX'> <FaFacebookF/> </a>
                  </li>
                </ul>
              </div>
              <div className='title_contact'>
                <div className='title'>
                  <h2>SALEY DIORI Abdel Nasser</h2>
                  <h4 className='h4t' data-text='Freelance Développeur Mobile/Web'>Freelance Développeur Mobile/Web</h4>
                </div>
                <div className='contact'>
                <button className="button "> <a href='https://api.whatsapp.com/send/?phone=%2B221780170884&text&app_absent=0' target='_blank'> Contacter moi <BiSend className='icon__contact' /> </a></button>
                </div>
              </div>

              <div className='photo'>
                <img className='img_photo' src='../images/nasser.jfif' alt='pas image' />
               
              </div>
  
            
          </section>
          <section className='section__skill' id='skills'>
            <h2 className='section__nom'>Compétences</h2>
            <div className='skill__container grid contenu'>
              <div>
                <div className='skill__content skill__open'>
                  <div className='skill__header'>
                    <BiCodeCurly className='skill__icon'/>
                    <div onClick={toogleclik1}>
                      <h1 className='skill__titles'>Développeur Frontend</h1>
                      <span className='skill__subtitle'>depus 4 ans</span>
                    </div>
                    <BiChevronDown className='skill__arrow'/>
                  </div>
                  { etat1 ?
                  <div className='skill__list'>
                    <div className='skill__data'>
                      <div className='skill__title'>
                        <h3 className='skill__nom'>HTML</h3>
                        <span className='skill__nbr'>90%</span>
                      </div>
                      <div className='skill__bar'>
                        <span className='skill__pourcentage skill__html'></span>
                      </div>
                    </div>
                    <div className='skill__data'>
                    <div className='skill__title'>
                      <h3 className='skill__nom'>css</h3>
                      <span className='skill__nbr'>70%</span>
                    </div>
                    <div className='skill__bar'>
                      <span className='skill__pourcentage skill__css'></span>
                    </div>
                  </div>
                  <div className='skill__data'>
                  <div className='skill__title'>
                    <h3 className='skill__nom'>react js</h3>
                    <span className='skill__nbr'>80%</span>
                  </div>
                  <div className='skill__bar'>
                    <span className='skill__pourcentage skill__react'></span>
                  </div>
                </div>
                  </div> : null}
                </div>
                <div className='skill__content skill__close'>
                  <div className='skill__header'>
                    <FaServer className='skill__icon'/>
                    <div onClick={toogleclik2}>
                      <h1 className='skill__titles'>Développeur backend</h1>
                      <span className='skill__subtitle'>depus 4 ans</span>
                    </div>
                    <BiChevronDown className='skill__arrow'/>
                  </div>
                  { etat2 ?
                  <div className='skill__list'>
                    <div className='skill__data'>
                      <div className='skill__title'>
                        <h3 className='skill__nom'>java</h3>
                        <span className='skill__nbr'>90%</span>
                      </div>
                      <div className='skill__bar'>
                        <span className='skill__pourcentage skill__java'></span>
                      </div>
                    </div>
                    <div className='skill__data'>
                    <div className='skill__title'>
                      <h3 className='skill__nom'>php</h3>
                      <span className='skill__nbr'>70%</span>
                    </div>
                    <div className='skill__bar'>
                      <span className='skill__pourcentage skill__php'></span>
                    </div>
                  </div>
                  <div className='skill__data'>
                  <div className='skill__title'>
                    <h3 className='skill__nom'>node js</h3>
                    <span className='skill__nbr'>80%</span>
                  </div>
                  <div className='skill__bar'>
                    <span className='skill__pourcentage skill__node'></span>
                  </div>
                </div>
                  </div> : null}
                </div>
                <div className='skill__content skill__close'>
                  <div className='skill__header'>
                    <FaNetworkWired className='skill__icon'/>
                    <div onClick={toogleclik3}>
                      <h1 className='skill__titles'>Administration Réseau</h1>
                      <span className='skill__subtitle'>depus 3 ans</span>
                    </div>
                    <BiChevronDown className='skill__arrow'/>
                  </div>
                  { etat3 ?
                  <div className='skill__list'>
                    <div className='skill__data'>
                      <div className='skill__title'>
                        <h3 className='skill__nom'>Mise en place un réseau informatique</h3>
                        <span className='skill__nbr'>90%</span>
                      </div>
                      <div className='skill__bar'>
                        <span className='skill__pourcentage skill__mise__reso'></span>
                      </div>
                    </div>
                    <div className='skill__data'>
                    <div className='skill__title'>
                      <h3 className='skill__nom'>Maintenance réseau</h3>
                      <span className='skill__nbr'>90%</span>
                    </div> 
                    <div className='skill__bar'>
                      <span className='skill__pourcentage skill__mait__reso'></span>
                    </div>
                  </div>
                  <div className='skill__data'>
                  <div className='skill__title'>
                    <h3 className='skill__nom'>Sécurité réseau</h3>
                    <span className='skill__nbr'>80%</span>
                  </div>
                  <div className='skill__bar'>
                    <span className='skill__pourcentage skill__secu__reso'></span>
                  </div>
                </div>
                  </div> : null}
                </div>
              </div>
            </div>
          </section>

          <section className='quali section' id='qualification'>
          <h2 className='section__nom'>Qualification</h2>
          <div className='quali__container container'>
            <div className='quali__tabs'>
                <div className='quali__button button__flex__etude ' data-traget='#etude' onClick={activeWork}>
                    <FaUserGraduate className='quali__icon' /> Etudes
                </div>

                <div className='quali__button button__flex__work' data-traget='#work' onClick={activeWork}>
                    <FaBriefcase className='quali__icon' /> Expériences professionels
                </div>
            </div>
            <div className='quali__sections'>
            { etude ? (
             <div className='qauli__content quali__active' data-content>
                <div className='quali__data'>
                  <div>
                    <h3 className='quali__title'>Master Génie Logiciel & Administration réseaux</h3>
                    <span className='quali__subtitle'>ESTM - Dakar</span>
                    <div>
                      <GoCalendar className='quali__calendar'/> 2017-2019
                    </div>
                  </div>
                  <div>
                    <span className='quali__rounder'></span>
                    <span className='quali__line'></span>
                  </div>
                </div>

                <div className='quali__data'>
                <div></div>

                <div>
                  <span className='quali__rounder'></span>
                  <span className='quali__line'></span>
                </div>
                <div>
                  <h3 className='quali__title'>licence Génie Logiciel & Administration réseaux</h3>
                  <span className='quali__subtitle'>ESTM - Dakar</span>
                  <div>
                    <GoCalendar className='quali__calendar'/> 2014-2017
                  </div>
                </div>
                
              </div>

              <div className='quali__data'>
              <div>
                <h3 className='quali__title'>Bac-D</h3>
                <span className='quali__subtitle'>CSP Kouara - Niamey</span>
                <div>
                  <GoCalendar className='quali__calendar'/> 2011-2014
                </div>
              </div>
              <div>
                <span className='quali__rounder'></span>
              </div>
            </div>
             </div>)
             :
             (<div>
              <div className='qauli__content'>
             <div className='quali__data'>
               <div>
                 <h3 className='quali__title'>Maintenance réseaux</h3>
                 <span className='quali__subtitle'>ASECNA - Dakar</span>
                 <div>
                   <GoCalendar className='quali__calendar'/> 2019
                 </div>
               </div>
               <div>
                 <span className='quali__rounderW'></span>
                 <span className='quali__lineW'></span>
               </div>
             </div>

             <div className='quali__data'>
             <div></div>

             <div>
               <span className='quali__rounderW'></span>
               <span className='quali__lineW'></span>
             </div>
             <div>
               <h3 className='quali__title'> Développement web et responsable sécurité informatique</h3>
               <span className='quali__subtitle'>SAHELCOM-NIGER</span>
               <div>
                 <GoCalendar className='quali__calendar'/> 2016
               </div>
             </div>
             
           </div>

           <div className='quali__data'>
           <div>
             <h3 className='quali__title'>Responsable de maintenances informatique</h3>
             <span className='quali__subtitle'>SONITEL S.A-NIGER </span>
             <div>
               <GoCalendar className='quali__calendar'/> 2016
             </div>
           </div>
           <div>
             <span className='quali__rounderW'></span>
             
           </div>
         </div>
          </div>
              </div>)}
             


             
            </div>
          </div>
          </section>


          <section className='services section' id='service'>
          <h2 className='section__nom'>Services</h2>
          <span className='section__subtitle'>Ce que je vous offre</span>

          <div className='services__container contenu '>
            <div className='services__content'>
              <GoCode className='services__icon' />
              <h3 className='service__title'>Développeur <br></br> Frontend</h3>
              <span className='button button--link button--small services__buttn' onClick={openModal}>
              Voir plus...
              <HiArrowRight className='button__icon' />
              </span>
              <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    style={customStyles}
                  >
              <div className='services__modal'>
                <div className='services__modal-content'>
                  <h4 className='services__modal-ttle'>Développeur <br></br> Frontend</h4>
                  <FaTimes className='services--modal_close' onClick={closeModal}/>

                  <ul className='services__modal-services grid'>
                    <li className='services__modal_service'>
                      <GiCheckMark className='services__modal_icon' />
                      <p>Développement d'interface utilisateur</p>
                    </li>
                    <li className='services__modal_service'>
                      <GiCheckMark className='services__modal_icon' />
                      <p>Développement des page web</p>
                    </li>
                    <li className='services__modal_service'>
                      <GiCheckMark className='services__modal_icon' />
                      <p>interaction des élement Ux</p>
                    </li>
                  </ul>
                </div>
              </div>
              </Modal>
            </div>

            <div className='services__content'>
              <BiCodeCurly className='services__icon' />
              <h3 className='service__title'>Développeur<br></br> Backend</h3>
              <span className='button button--link button--small services__buttn' onClick={openModal1}>
              Voir plus...
              <HiArrowRight className='button__icon' />
              </span>

              <Modal
              isOpen={modalIsOpen1}
              onRequestClose={closeModal1}
              style={customStyles}
            >

              <div className='services__modal'>
                <div className='services__modal-content'>
                  <h4 className='services__modal-ttle'>Développeur<br></br> Backend</h4>
                  <FaTimes className='services--modal_close' onClick={closeModal1}/>

                  <ul className='services__modal-services grid'>
                    <li className='services__modal_service'>
                      <GiCheckMark className='services__modal_icon' />
                      <p>Gestion des Bases de données</p>
                    </li>
                    <li className='services__modal_service'>
                      <GiCheckMark className='services__modal_icon' />
                      <p>Développement Web-service</p>
                    </li>
                    <li className='services__modal_service'>
                      <GiCheckMark className='services__modal_icon' />
                      <p>création des API REST</p>
                    </li>
                  </ul>
                </div>
              </div>
              </Modal>
            </div>


            <div className='services__content'>
              <FaNetworkWired className='services__icon' />
              <h3 className='service__title'>Administration <br></br> Réseaux</h3>
              <span className='button button--link button--small services__buttn' onClick={openModal2}>
              Voir plus...
              <HiArrowRight className='button__icon' />
              </span>


              <Modal
              isOpen={modalIsOpen2}
              onRequestClose={closeModal2}
              style={customStyles}
            >
              <div className='services__modal'>
                <div className='services__modal-content'>
                  <h4 className='services__modal-ttle'>Administration <br></br> Réseaux</h4>
                  <FaTimes className='services--modal_close' onClick={closeModal2}/>

                  <ul className='services__modal-services grid'>
                    <li className='services__modal_service'>
                      <GiCheckMark className='services__modal_icon' />
                      <p>Analyse et mise en place d'un réseau infromatique</p>
                    </li>
                    <li className='services__modal_service'>
                      <GiCheckMark className='services__modal_icon' />
                      <p>Gestion Windows Server 2016</p>
                    </li>
                    <li className='services__modal_service'>
                      <GiCheckMark className='services__modal_icon' />
                      <p>Maintemance & sécurité des réseaux</p>
                    </li>
                    <li className='services__modal_service'>
                      <GiCheckMark className='services__modal_icon' />
                      <p>sécurité électronique</p>
                    </li>
                  </ul>
                </div>
              </div>
              </Modal>
            </div>
          </div>
          </section>
    </main>
    </div>
  );
}

export default App;
